module.exports = __webpack_public_path__ + "media/images/past_order_history/ic_Category-d894a8076bf2d1f8a9e3f7e655d988e4.png";